/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { SequenceSubType } from './SequenceSubType';
import {
    SequenceSubTypeFromJSON,
    SequenceSubTypeFromJSONTyped,
    SequenceSubTypeToJSON,
} from './SequenceSubType';

/**
 * 
 * @export
 * @interface TrackItDataSequenceAxisDto
 */
export interface TrackItDataSequenceAxisDto {
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceAxisDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceAxisDto
     */
    measurementId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceAxisDto
     */
    parentSequenceId?: number | null;
    /**
     * 
     * @type {SequenceSubType}
     * @memberof TrackItDataSequenceAxisDto
     */
    sequencePartType?: SequenceSubType;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataSequenceAxisDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceAxisDto
     */
    byteCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceAxisDto
     */
    pointCount?: number;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataSequenceAxisDto
     */
    $type?: TrackItDataSequenceAxisDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItDataSequenceAxisDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItDataSequenceAxisDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataSequenceAxisDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItDataSequenceAxisDtoTypeEnum = typeof TrackItDataSequenceAxisDtoTypeEnum[keyof typeof TrackItDataSequenceAxisDtoTypeEnum];



/**
 * Check if a given object implements the TrackItDataSequenceAxisDto interface.
 */
export function instanceOfTrackItDataSequenceAxisDto(value?: unknown): value is TrackItDataSequenceAxisDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItDataSequenceAxisDtoTypeEnum)[0];
}

export function TrackItDataSequenceAxisDtoFromJSON(json: any): TrackItDataSequenceAxisDto {
    return TrackItDataSequenceAxisDtoFromJSONTyped(json, false);
}

export function TrackItDataSequenceAxisDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItDataSequenceAxisDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'measurementId': json['measurementId'] == null ? undefined : json['measurementId'],
        'parentSequenceId': json['parentSequenceId'] == null ? undefined : json['parentSequenceId'],
        'sequencePartType': json['sequencePartType'] == null ? undefined : SequenceSubTypeFromJSON(json['sequencePartType']),
        'unit': json['unit'] == null ? undefined : json['unit'],
        'byteCount': json['byteCount'] == null ? undefined : json['byteCount'],
        'pointCount': json['pointCount'] == null ? undefined : json['pointCount'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItDataSequenceAxisDtoToJSON(value?: TrackItDataSequenceAxisDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'measurementId': value['measurementId'],
        'parentSequenceId': value['parentSequenceId'],
        'sequencePartType': SequenceSubTypeToJSON(value['sequencePartType']),
        'unit': value['unit'],
        'byteCount': value['byteCount'],
        'pointCount': value['pointCount'],
        '$type': value['$type'],
    });
}

